import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import Html from "./Html";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Pages/actions/user";
import ApiClient from "../../../methods/api/apiClient";
import { memo } from "react";
import socketModel from "../../../models/socketModel";

const Header = memo(function Header({ setIsOpen, isOpen }) {
  const user = useSelector((state) => state.user);
  const toggle = () => {
    setIsOpen(!isOpen);
    localStorage.setItem("sidebar", !isOpen);
  };
  const [filters, setFilter] = useState({
    monthly: "monthly",
    type: "monthly",
    startDate: "",
    endDate: "",
  });
  const [isOpen1, setIsOpen1] = useState(false);
  let messagecount = localStorage.getItem("unreadMessages") || 0;
  const [datamngnotification, setDatamngnotification] = useState([]);
  const [messageCount, setUnreadMessagesCount] = useState(messagecount);
  const [notificationTotal, setnotificationTotal] = useState(0);

  const history = useNavigate();
  const dispatch = useDispatch();

  const searchState = { data: "" };

  const Logout = () => {
    dispatch(logout());
    localStorage.removeItem("persist:admin-app");
    localStorage.removeItem("token");
    // localStorage.removeItem("loginTime")
    socketModel.emit("user-offline", { userId: user?._id || user?.id });
    socketModel.disconnect();
    history("/login");
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
    // if (searchState.data) {
    //   dispatch(search_success(''))
    // }
  }, []);

  useEffect(() => {
    setSearch(searchState.data);
  }, [searchState]);

  const [search, setSearch] = useState("");

  const searchHandle = (e) => {
    e.preventDefault();
    // dispatch(search_success(search))
  };

  const searchChange = (e) => {
    setSearch(e);
    if (!e) {
      // dispatch(search_success(''))
    }
  };
  const getDatamngnotification = (p = {}) => {
    // setLoader(true);
    // let filter = { ...filters, ...p ,  managerId: user._id,  };
    let filter = { ...filters, ...p };

    ApiClient.get(
      `dash/shift/notification?status=unread&managerId=${user._id}`,
      filter
    ).then((res) => {
      if (res.success) {
        setDatamngnotification(
          res.data.map((itm) => {
            // itm.id = itm._id;
            return itm;
          })
        );

        setnotificationTotal(res.total);
      }
      // setLoader(false);
    });
  };

  const clear = () => {
    setSearch("");
    // dispatch(search_success(''))
  };

  useEffect(() => {
    socketModel.on("new-order", (data) => {
      // dispatch(order_success(data.getNotification?.data))
      console.log(data, "??????????");
      if (data.getNotification?.managerId == user._id) {
        setnotificationTotal(data?.getNotification?.totalNotification);
      }

      // setnotificationData(data?.getNotification?.findAllNotification);
    });
  }, []);
  useEffect(() => {
    getDatamngnotification();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const shouldBeOpen = screenWidth > 767;
      setIsOpen(!shouldBeOpen);
      localStorage.setItem("sidebar", shouldBeOpen);
    };

    handleResize(); // run once on mount

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Html
      isOpen={isOpen}
      toggle={toggle}
      notificationTotal={notificationTotal}
      searchHandle={searchHandle}
      search={search}
      user={user}
      searchChange={searchChange}
      isOpen1={isOpen1}
      clear={clear}
      Logout={Logout}
      messageCount={messageCount}
    />
  );
});

export default Header;
